import { useState, useEffect } from 'react';

interface TimerProps {
  endTime: number;
}

function Timer({ endTime }: TimerProps) {
  const [timeLeft, setTimeLeft] = useState<number>(Math.max(0, endTime - Date.now()));

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = Math.max(0, endTime - Date.now());
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 100);
    return () => clearInterval(interval);
  }, [endTime]);

  return (
    <span className="inline-flex justify-center items-center bg-gray-700 text-white font-semibold px-3 py-1 rounded-full text-lg shadow-sm">
      {Math.ceil(timeLeft / 1000)}s
    </span>
  );
}

export default Timer;
